import WarningAuthModalComponent from "../components/warning-auth-modal-component";
import {RenderPosition, remove, render} from "../utils/render";


export default class WarningAuthController {
  constructor({message = ``}) {
    this._message = message;
    this._modalComponent = null;

    this._onEscPressModalHandler = this._onEscPressModalHandler.bind(this);
  }

  show() {
    document.querySelector(`body`).classList.add(`overflowHidden`);
    document.addEventListener(`keydown`, this._onEscPressModalHandler);

    this._modalComponent = new WarningAuthModalComponent({
      message: this._message,
    });
    render(document.querySelector(`body`), this._modalComponent.getElement(), RenderPosition.BEFOREEND);

    this._modalComponent.setCloseButtonClickHandler(() => this._remove());
    setTimeout(() => this._modalComponent.setShowClass(), 100);
  }

  _remove() {
    this._modalComponent.getElement().classList.add(`modal--hide`);
    document.querySelector(`body`).classList.remove(`overflowHidden`);
    document.removeEventListener(`keydown`, this._onEscPressModalHandler);
    setTimeout(() => remove(this._modalComponent), 1000);
  }

  _onEscPressModalHandler(evt) {
    if (evt.key === `Escape`) {
      this._remove();
    }
  }
}
